import { FEATURE_FLAG_VALUE } from '@prosaas/psw-events';
import { request } from '@prosaas/psw-utils';
import { useEffect, useState } from 'react';
import { useUserId } from './useUserId';
import { IRequestFeatureFlagPayload } from '../utils/interfaces';

interface IFeatureFlags {
  hasShopSellingFeatureEnabled: boolean;
  hasProductListFeatureEnabled?: boolean;
}

const SHOP_SELLING = 'business_ecommerce_20230420_frontend_shop_selling';
const PRODUCT_LIST = 'tech_logistics_13072023_frontend_product_list';

const requestFeatureFlag = ({ flagName, defaultValue, userId }: IRequestFeatureFlagPayload) => {
  return request(FEATURE_FLAG_VALUE, { flagName, defaultValue, userId });
};

export function useFeatureFlags(): IFeatureFlags {
  const [hasShopSellingFeatureEnabled, setHasShopSellingFeatureEnabled] = useState<boolean>(false);
  const [hasProductListFeatureEnabled, setHasProductListFeatureEnabled] = useState<boolean>(false);
  const userId = useUserId();

  useEffect(() => {
    requestFeatureFlag({
      flagName: SHOP_SELLING,
      defaultValue: false,
      userId,
    }).then(setHasShopSellingFeatureEnabled);

    requestFeatureFlag({
      flagName: PRODUCT_LIST,
      defaultValue: false,
      userId,
    }).then(setHasProductListFeatureEnabled);
  }, [setHasShopSellingFeatureEnabled, setHasProductListFeatureEnabled, userId]);

  return { hasShopSellingFeatureEnabled, hasProductListFeatureEnabled };
}
